import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {Formik} from "formik";
import s from "./ToAnLuxPayTransferForm.module.css";
import {Popover} from "antd";
import info from "../../assets/img/personalAccount/information.svg";
import CustomDropdown from "../ui/CustomDropdown/CustomDropdown";
import MyInput from "../ui/MyInput/MyInput";
import classnames from "classnames";
import MyBtn from "../ui/MyBtn/MyBtn";
import {motion} from "framer-motion";
import * as yup from "yup";
import CustomDropdownForAccounts from "../ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import {useAccountsForSelect} from "../../hooks/useAccountsForSelect";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";

import {
    CheckAvailableAccountsByEmail, CheckAvaliableAccountByWalletId,
    CheckAvaliableAccountsByPhone,
    CurrencyHelper,
    ResetFieldByTransferMethod
} from "./Helpers";
import CustomModal from "../ui/CustomModal/CustomModal";
import {getChallengeDataThunk, getFeesForTransaction} from '../../store/reducers/ActionCreators';
import {PrepareDataForLuxpayTransaction} from "../../helpers/PrepareDataForLuxpayTransaction";
import PhoneCodesInput from "../ui/PhoneCodesInput/PhoneCodesInput";
import {setTransferDataPreview} from "../../store/reducers/TransactionsSlice/TransactionsSlice";
import {useNavigate} from "react-router-dom";
import AddDoc from "../AddDoc/AddDoc";
import {FormikPersist} from "../BankTransferFormPersonal/FormHelpers/FormikPersist";
import {clearFormByChangeType} from "../../helpers/clearFormHelper";

type PropsType = {
    setCurrent?: Dispatch<SetStateAction<number>>
    id?: string | number;
    isButtonDisable: boolean | undefined
    setIsButtonDisabled: Dispatch<React.SetStateAction<boolean>>
    tabIndex?: number
}

const ToAnLuxPayTransferForm = (props: PropsType) => {

    const [currency, setCurrency] = useState('')
    const [accountNumber, setAccountNumber] = useState('')
    const [errorText, setErrorText] = useState('')
    const [isMobile, setIsMobile] = useState(false)
    const [isHisOwnRecipientData, setIsHisOwnRecipientData] = useState<boolean | null>(false)
    const [isAvailableAccountExists, setIsAvailableAccountExists] = useState<boolean | null>(true)
    const [isListOfAccounts, setIsListOfAccounts] = useState<any>()
    const [isDocumentErrorModalOpen, setIsDocumentErrorModalOpen] = useState<boolean | null>(false)
    const [documentErrorModalText, setDocumentErrorModalText] = useState<string | null>('')
    const [isLimitPopupOpen, setIsLimitPopupOpen] = useState<boolean | null>(false)
    const [limitType, setLimitType] = useState<string | null>('');
    const [isNotEnoughMoney, setIsNotEnoughMoney] = useState<boolean | null>(false)
    const [isLocallyButtonDisabled, setIsLocallyButtonDisabled] = useState(true)
    const [isInputErrorShow, setIsInputErrorShow] = useState(false)
    const navigate = useNavigate()

    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)

    const accountsList = useAccountsForSelect().filter((account: any) => account.accountMainIban !== "ALL")
    const token = useAppSelector(state => state.userReducer.userToken)
    const transferMethods = [
        'Wallet Id',
        'Email',
        'Phone number',
    ]

    const accountType = [
        'Personal',
        'Business',
    ]

    const dispatch = useAppDispatch()

    useEffect(() => {
        if (window.innerWidth <= 768) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
        return () => {
            props.setIsButtonDisabled(false)
        }
    }, [window.innerWidth])

    const getFees = async (obj: any) => {

        const preparedData = PrepareDataForLuxpayTransaction(obj, accountId)

        const resp = await dispatch(getFeesForTransaction(token, preparedData))

        return resp
    }

    const getChallengeData = async (obj: any) => {
        const preparedData = PrepareDataForLuxpayTransaction(obj, accountId)

        const resp = await dispatch(getChallengeDataThunk(token, {transaction: preparedData}))

        return resp
    }

    const transferInitialValues = {
        accNumberFrom: '',
        accNumberTo: '',
        email: '',
        phoneNumber: '',
        emailLanguage: 'EN',
        reference: '',
        templateName: '',
        amount: '',
        transferMethod: 'Wallet Id',
        type: 'internal',
        invoice: {
            name: '',
            data: ''
        },
        purpose: '',
        hiddenAccountNumber: '',
        transferCurrency: '',
        accountType: '',
        clientId: ''
    }

    const validationSchema = yup.object({
        accNumberFrom: yup.string().required('Required field'),
        accNumberTo: yup.string().required('Required field').max(40, 'max 40 symbols'),
        transferMethod: yup.string().required('Required field'),
        accountType: yup.string().test({
            message: 'Required field',
            test: function (value) {
                const {transferMethod} = this.parent;
                if (isListOfAccounts?.length === 2 && (transferMethod === 'Phone number' || transferMethod === 'Email')) {
                    return value !== undefined && value !== null && value !== '';
                }
                return true;
            },
        }),
        phoneNumber: yup.string().test({
            message: 'Required field',
            test: function (value) {
                const {transferMethod} = this.parent;
                if (transferMethod === 'Phone number') return value !== undefined && value !== null && value !== '';
                return true
            },
        }),
        email: yup.string().test({
            message: 'Required field',
            test: function (value) {
                const {transferMethod} = this.parent;
                if (transferMethod === 'Email') return value !== undefined && value !== null && value !== '';
                return true
            },
        }),
        amount: yup.string()
            .matches(/^[-+]?[0-9]*[.]?[0-9]+(?:[eE][-+]?[0-9]+)?$/, "Invalid format")
            .required('Required field')
            .max(10, 'max 10 digits')
            .test(
                'no-leading-zero',
                'invalid format',
                (value, context) => {

                    const tempArr = context.originalValue.split('')

                    const onlyZero = tempArr.every((item: string) => {
                        if (item === '0') {
                            return true
                        }
                    })

                    if (context.originalValue && onlyZero) {
                        return false
                    } else if ((context.originalValue.match(/,/g) || []).length > 1) {
                        return false
                    }
                    return true
                }
            )
            .test(
                'positive-number',
                'Value must be positive',
                (value) => {
                    const num = parseFloat(value);
                    return !isNaN(num) && num >= 0;
                }
            )
            .test(
                'max-decimal-places',
                'max 2 symbols after .',
                (value) => {
                    const parts = value.split('.')
                    return parts.length === 1 || parts[1].length <= 2
                }
            ),
        templateName: yup.string().max(100, 'max 100 symbols'),
        purpose: yup.string().max(100, 'max 100 symbols')
    })

    useEffect(() => {
        if (!accountNumber) {
            return
        }
        sessionStorage.setItem("accountNumber", accountNumber)
    }, [accountNumber])

    useEffect(() => {
        const accNumber = sessionStorage.getItem("accountNumber")
        if (accNumber) {
            setAccountNumber(accNumber)
        }
    }, [])

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            <CustomModal type="error" isNotify isModalOpen={isNotEnoughMoney} setIsModalOpen={setIsNotEnoughMoney}>
                <div className={s.modal_content}>
                    <div className={s.popup_subtitle}>
                        <span className={s.error}>Failed!</span> The transfer cannot be made due to insufficient funds.
                    </div>
                    <div className={s.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"}
                               onClick={() => setIsNotEnoughMoney(false)}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal type="error" isNotify isModalOpen={isDocumentErrorModalOpen}
                         setIsModalOpen={setIsDocumentErrorModalOpen}>
                <div className={s.modal_content}>
                    <div className={s.popup_subtitle}>
                        <span className={s.error}>Failed!</span> {documentErrorModalText}
                    </div>
                    <div className={s.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"}
                               onClick={() => setIsDocumentErrorModalOpen(null)}/>
                    </div>
                </div>
            </CustomModal>

            <CustomModal data-testid="send-transfer-error-popup" type="error" isNotify isModalOpen={isLimitPopupOpen} setIsModalOpen={setIsLimitPopupOpen}>
                <div className={s.modal_content}>
                    <div className={s.popup_subtitle}>
                        <span className={s.error}>Failed!</span> The transaction is impossible due to exceeding {limitType} limit.
                        Please contact <a className={s.popup_link} href='mailto:support@luxpay.lt'>support@luxpay.lt</a>&nbsp;
                        if you have any questions.
                    </div>
                    <div className={s.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => setIsLimitPopupOpen(false)} />
                    </div>
                </div>
            </CustomModal>

            <Formik initialValues={transferInitialValues}
                    validationSchema={validationSchema}
                    validateOnBlur={true}
                    onSubmit={async (values, {resetForm}) => {
                        //@ts-ignore

                        const selectedAccount = isListOfAccounts?.find((account: any) => (
                            account.clientType === values.accountType.toLocaleLowerCase())
                        )

                        const selectedAccountWalletId = selectedAccount?.userNumber

                        if (selectedAccount) {
                            values.hiddenAccountNumber = selectedAccount.number;
                        }

                        let tempTransferMethod: string | null = ''

                        if (values.transferMethod === 'Phone number') {
                            tempTransferMethod = 'phone'
                        }

                        if (values.transferMethod === 'Email') {
                            tempTransferMethod = 'email'
                        }

                        if (values.transferMethod === 'Wallet Id') {
                            tempTransferMethod = 'account'
                        }

                        const tempData = {
                            ...values,
                            transferMethod: tempTransferMethod,
                            accountNumber: accountNumber,
                            transferCurrency: currency,
                            accountId: accountId,
                            accNumberFrom: accountNumber,
                            clientId: selectedAccountWalletId || values.clientId
                        }

                        try {

                            const feesData = await getFees(tempData)

                            const challengeData = await getChallengeData(tempData)

                            dispatch(setTransferDataPreview({
                                ...tempData,
                                fee: feesData.data.fee,
                                totalAmount: feesData.data.totalAmount,
                                tabIndex: props.tabIndex,
                                challengeData: challengeData.data
                            }))

                            navigate('transfer-data-preview')

                        } catch (e: any) {

                            if (e.response.data === 'Daily Limit') {
                                setLimitType("daily")
                                setIsLimitPopupOpen(true)
                                return
                            } else if (e.response.data === 'Monthly Limit') {
                                setLimitType("monthly")
                                setIsLimitPopupOpen(true)
                                return
                            } else if (e.response.data.includes('User account is not active')) {
                                setDocumentErrorModalText('The user account is not active')
                                setIsDocumentErrorModalOpen(true)
                                return
                            } else {
                                setIsNotEnoughMoney(true)
                            }
                        }
                    }}
            >
                {({
                      values,
                      setValues,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>

                        <CustomModal type="error" isNotify isModalOpen={!isAvailableAccountExists}
                                     setIsModalOpen={setIsAvailableAccountExists}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> The transfer cannot be made to the
                                    specified&nbsp;
                                    {values.transferMethod.toLowerCase()} due to the lack of an account with the
                                    recipient.
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        setIsAvailableAccountExists(true)
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={isHisOwnRecipientData}
                                     setIsModalOpen={setIsHisOwnRecipientData}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> {errorText}
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        setIsHisOwnRecipientData(null)
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <div className={s.form_header}>
                            <div className={[s.input_block, s.mobileMargin].join(' ')}>
                                <div className={s.input_label}>
                                    <span className={s.title_label}><span
                                        className={s.red}>*</span> Payer account</span>
                                    <Popover content={"Please select the account you wish to make a transfer from."}
                                             color={'#EEEFEF'}
                                             overlayInnerStyle={{
                                                 fontFamily: 'Manrope',
                                                 width: '280px',
                                                 padding: '13px 16px',
                                                 cursor: 'pointer',
                                                 backgroundColor: '#E7F0EC'
                                             }}
                                    >
                                        <img src={info} alt=""/>
                                    </Popover>
                                </div>
                                <CustomDropdownForAccounts
                                    items={accountsList}
                                    placeholder={"Please select the account"}
                                    id="accNumberFrom"
                                    name="accNumberFrom"
                                    isError={errors.accNumberFrom}
                                    touched={touched.accNumberFrom}
                                    setCurrency={(selectedCurrency) => {
                                        setCurrency(selectedCurrency);
                                    }}
                                    setAccountNumber={setAccountNumber}
                                />
                                {errors.accNumberFrom && touched.accNumberFrom &&
                                    <div className={s.error_message}>{errors.accNumberFrom}</div>}
                            </div>

                            <div className={s.input_block}>
                                <div className={s.input_label}>
                                    <span className={s.title_label}><span
                                        className={s.red}>*</span> Transfer Method</span>
                                    <Popover content={"Choose one of the recipient’s identifiers: their Luxpay" +
                                        " account, email address or phone number."}
                                             color={'#EEEFEF'}
                                             overlayInnerStyle={{
                                                 fontFamily: 'Manrope',
                                                 width: '280px',
                                                 padding: '13px 16px',
                                                 cursor: 'pointer',
                                                 backgroundColor: '#E7F0EC'
                                             }}
                                    >
                                        <img src={info} alt=""/>
                                    </Popover>
                                </div>
                                <CustomDropdown
                                    placeholder={"Please select the transfer method"}
                                    items={transferMethods}
                                    id="transferMethod"
                                    name="transferMethod"
                                    isError={errors.transferMethod}
                                    touched={touched.transferMethod}
                                    setItem={(value: string) => {
                                        clearFormByChangeType(
                                            values,
                                            setValues,
                                            [
                                                "purpose",
                                                "transferCurrency",
                                                "type",
                                                "amount",
                                                "emailLanguage",
                                                "accNumberFrom",
                                            ]
                                        )
                                        setIsListOfAccounts(null)
                                        setFieldValue('transferMethod', value);
                                    }}
                                />
                            </div>
                        </div>

                        <div className={s.block}>
                            <div className={s.title}>
                                Outgoing Payment Details
                            </div>
                            <div className={s.rowWrapperElements}>


                                <div className={s.input_block}>
                                    {values.transferMethod === 'Wallet Id'
                                        && <div className={s.input_block} data-testid={"walletId-transfer-form"}>
                                            <div className={s.input_label}>
                                                <span className={s.title_label}><span className={s.red}>*</span> Wallet ID</span>
                                            </div>
                                            <MyInput id={"accNumberTo"}
                                                     name={"accNumberTo"}
                                                     touched={touched.accNumberTo}
                                                     value={values.accNumberTo}
                                                     onChange={handleChange}
                                                     isError={isInputErrorShow || (touched.accNumberTo && !!errors.accNumberTo)}
                                                     placeholder={"Enter recipient's Wallet Id"}
                                            />
                                            {errors.accNumberTo && touched.accNumberTo &&
                                                <div className={s.error_message}>{errors.accNumberTo}</div>}
                                            {isInputErrorShow &&
                                                <div className={s.error_message}>invalid wallet Id</div>}
                                        </div>
                                    }

                                    {values.transferMethod === 'Email'
                                        && <div className={s.input_block} data-testid={"email-transfer-form"}>
                                            <div className={s.input_label}>
                                                <span className={s.title_label}><span
                                                    className={s.red}>*</span> Email</span>
                                            </div>
                                            <MyInput id={"email"}
                                                     name={"email"}
                                                     touched={touched.email}
                                                     value={values.email}
                                                     onChange={handleChange}
                                                     isError={isInputErrorShow || (touched.email && !!errors.email)}
                                            />
                                            {errors.email && touched.email &&
                                                <div className={s.error_message}>{errors.email}</div>}
                                            {isInputErrorShow &&
                                                <div className={s.error_message}>invalid email</div>}
                                        </div>
                                    }

                                    {values.transferMethod === 'Phone number'
                                        && <div className={s.input_block} data-testid={"phoneNumber-transfer-form"}>
                                            <div className={s.input_label}>
                                                <span className={s.title_label}><span className={s.red}>*</span> phone number</span>
                                                <Popover
                                                    content={"Phone number in international format."}
                                                    color={'#EEEFEF'}
                                                    overlayInnerStyle={{
                                                        fontFamily: 'Manrope',
                                                        width: '280px',
                                                        padding: '13px 16px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#E7F0EC'
                                                    }}
                                                >
                                                    <img src={info} alt=""/>
                                                </Popover>
                                            </div>
                                            <PhoneCodesInput
                                                id="phoneNumber"
                                                name="phoneNumber"
                                                error={isInputErrorShow || (touched.phoneNumber && !!errors.phoneNumber)}
                                                touched={touched.phoneNumber}
                                                tiny
                                            />
                                            {isInputErrorShow &&
                                                <div className={s.error_message}>invalid phone number</div>}
                                        </div>
                                    }

                                </div>
                                <div className={`${s.mobile_row} ${s.mobileOrderAmount}`}>
                                    <div className={classnames(s.input_block, s.short)}>
                                        <div className={s.input_label}>
                                            <span className={s.title_label}><span
                                                className={s.red}>*</span> Amount</span>
                                            <Popover
                                                content={"Select a currency and enter the transfer amount.\n" +
                                                    "In the account balance in the selected currency is insufficient, the system " +
                                                    "will automatically offer you to top up using funds in a different currency " +
                                                    "you have on the account."}
                                                color={'#EEEFEF'}
                                                overlayInnerStyle={{
                                                    fontFamily: 'Manrope',
                                                    width: '280px',
                                                    padding: '13px 16px',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#E7F0EC'
                                                }}
                                            >
                                                <img src={info} alt=""/>
                                            </Popover>
                                        </div>
                                        <MyInput id={"amount"}
                                                 name={"amount"}
                                                 touched={touched.amount}
                                                 value={values.amount}
                                                 onChange={handleChange}
                                                 isError={touched.amount && !!errors.amount}
                                        />
                                        {errors.amount && touched.amount &&
                                            <div
                                                className={classnames(s.error_message, s.error_amount)}>{errors.amount}</div>}
                                    </div>

                                    <div className={s.currency_dropdown}>
                                        <div className={s.input_label}>
                                            <span
                                                className={`${s.title_label} ${s.currency_mobile_hidden} `}>Currency</span>
                                        </div>
                                        <MyInput
                                            id={"transferCurrency"}
                                            name={"transferCurrency"}
                                            value={currency}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <div className={`${s.input_block} ${s.mobileOrderPurpose}`}>
                                    <div className={s.input_label}>
                                        <span className={s.title_label}>Purpose</span>
                                    </div>
                                    <MyInput id={"purpose"}
                                             name={"purpose"}
                                             touched={touched.purpose}
                                             value={values.purpose}
                                             onChange={handleChange}
                                             isError={errors.purpose}
                                             placeholder={"Enter your purpose of payment"}
                                             padding='17px 16px'
                                             isMobile={isMobile}
                                    />
                                    {errors.purpose && touched.purpose &&
                                        <div
                                            className={classnames(s.error_message, s.error_amount)}>{errors.purpose}</div>}
                                </div>


                                {
                                    //@ts-ignore
                                    isListOfAccounts?.length > 1 &&
                                    <div className={`${s.input_block} ${s.showForDesk}`}>
                                        <div className={s.input_label}>
                                            <span className={s.title_label}><span className={s.red}>*</span> RECIPIENT ACCOUNT TYPE</span>
                                        </div>
                                        <CustomDropdown
                                            items={accountType}
                                            id="accountType"
                                            name="accountType"
                                            isError={errors.accountType}
                                            touched={touched.accountType}

                                        />
                                        {errors.accountType && touched.accountType &&
                                            <div className={s.error_message}>{errors.accountType}</div>}
                                    </div>
                                }

                            </div>


                        </div>

                        {!props.id && <div className={s.block}>
                            <div className={s.title}>
                                Save the Transfer Details as a Template
                            </div>

                            <div className={s.row}>
                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        <span className={s.title_label}>template Name</span>
                                        <Popover
                                            content={"In order to save this transfer as a template, please enter the " +
                                                "template name."}
                                            color={'#EEEFEF'}
                                            overlayInnerStyle={{
                                                fontFamily: 'Manrope',
                                                width: '280px',
                                                padding: '13px 16px',
                                                cursor: 'pointer',
                                                backgroundColor: '#E7F0EC'
                                            }}
                                        >
                                            <img src={info} alt=""/>
                                        </Popover>
                                    </div>
                                    <MyInput id={"templateName"}
                                             name={"templateName"}
                                             touched={touched.templateName}
                                             value={values.templateName}
                                             onChange={handleChange}
                                             isError={errors.templateName}
                                    />
                                    {errors.templateName &&
                                        <div className={s.error_message}>{errors.templateName}</div>}
                                </div>

                                <div className={s.input_block}>

                                </div>
                            </div>
                        </div>}

                        <AddDoc
                            invoice={values.invoice}
                            setIsDocumentErrorModalOpen={setIsDocumentErrorModalOpen}
                            setDocumentErrorModalText={setDocumentErrorModalText}
                            setFieldValue={setFieldValue}
                        />

                        <div className={s.continue_block}>
                            <div className={s.required}>
                                <div>
                                    <span><span className={s.red}>*</span> required fields.</span>
                                </div>
                            </div>
                            {!props.id && <div className={s.button_wrapper}>
                                <MyBtn
                                    title={"Continue"}
                                    large
                                    type={"submit"}
                                    localDisable={props.isButtonDisable || isLocallyButtonDisabled}
                                    isPersonalAccountBtn
                                />
                            </div>}
                        </div>


                        <CurrencyHelper
                            accountsList={accountsList}
                            payerAccount={values.accNumberFrom}
                            setCurrency={setCurrency}
                            setAccountNumber={setAccountNumber}
                            errors={errors}
                            values={values}
                        />

                        <CheckAvailableAccountsByEmail
                            name={"hiddenAccountNumber"}
                            accNumberTo={"accNumberTo"}
                            setErrorText={setErrorText}
                            setIsHisOwnRecipientData={setIsHisOwnRecipientData}
                            email={values.email}
                            token={token}
                            currency={currency}
                            setIsAvailableAccountExists={setIsAvailableAccountExists}
                            setIsListOfAccounts={setIsListOfAccounts}
                            setIsButtonDisabled={setIsLocallyButtonDisabled}
                            setIsInputErrorShow={setIsInputErrorShow}
                            setFieldValue={setFieldValue}
                        />

                        <CheckAvaliableAccountsByPhone
                            name={"hiddenAccountNumber"}
                            accNumberTo={"accNumberTo"}
                            setErrorText={setErrorText}
                            setIsHisOwnRecipientData={setIsHisOwnRecipientData}
                            phone={values.phoneNumber}
                            token={token}
                            currency={currency}
                            setIsAvailableAccountExists={setIsAvailableAccountExists}
                            setIsListOfAccounts={setIsListOfAccounts}
                            setIsButtonDisabled={setIsLocallyButtonDisabled}
                            setIsInputErrorShow={setIsInputErrorShow}
                            setFieldValue={setFieldValue}
                        />

                        <CheckAvaliableAccountByWalletId
                            name={"hiddenAccountNumber"}
                            setErrorText={setErrorText}
                            setIsHisOwnRecipientData={setIsHisOwnRecipientData}
                            account={values.accNumberTo}
                            transferMethod={values.transferMethod}
                            token={token}
                            currency={currency}
                            setIsAvailableAccountExists={setIsAvailableAccountExists}
                            setIsButtonDisabled={setIsLocallyButtonDisabled}
                            setIsInputErrorShow={setIsInputErrorShow}
                            setFieldValue={setFieldValue}
                        />

                        <ResetFieldByTransferMethod
                            name={"email"}
                            handleReset={() => {
                            }}
                        />
                        <ResetFieldByTransferMethod
                            name={"phoneNumber"}
                            handleReset={() => {
                            }}
                        />
                        <ResetFieldByTransferMethod
                            name={"accNumberTo"}
                            handleReset={() => {
                            }}
                        />

                        <FormikPersist name="luxpay-transfer-form"/>

                    </form>
                )}
            </Formik>
        </motion.div>
    );
};

export default ToAnLuxPayTransferForm;
